import fetch from 'auth/FetchInterceptor'

const employerService = {}
const apiRoute = '/employer'

employerService.getProfile = async function () {
  try {
    const res = await fetch({
      url: `${apiRoute}/profile`,
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

employerService.updateProfile = async function (data) {
  try {
    const res = await fetch({
      url: `${apiRoute}/update`,
      method: 'patch',
      data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

/** Accept employer agreement. Body: `{ signature: CloudFront URL }`. */
employerService.acceptAgreement = async function (data) {
  try {
    const res = await fetch({
      url: `${apiRoute}/agreement/accept`,
      method: 'post',
      data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
    throw err
  }
}

export default employerService
